<template>
  <v-card
    v-if="calculator"
    class="white vetalfa-view"
    :max-width="_getMaxWidth()"
    flat
  >
    <div class="vetalfa-global-header" ref="screenHeader" v-if="!componentMode">
      <vetalfa-small-header
        showBreadCrumbAndTitle
        :breadcrumb="!!calculator ? calculator.name : null"
        :title="category ? category.portugueseName : null"
        hasHeaderOptions
      ></vetalfa-small-header>
      <v-row no-gutters justify="center">
        <vetalfa-drugs-header
          :name="calculator.name"
          :description="calculator.classes[0]"
          :displayCalculator="false"
          class="vetalfa-max-width my-4 px-2"
        >
        </vetalfa-drugs-header>
      </v-row>
    </div>
    <div ref="screenContent" style="height: 100%">
      <vetalfa-section-title
        :prop="_getCalculatorsLabel('SELECT_EQUIPMENT_TYPE')"
      ></vetalfa-section-title>
      <v-item-group v-model="equipmentModel" :value="0" mandatory>
        <v-row class="ma-0 pa-0 my-4" justify="space-around">
          <v-col :cols="_isMobile() ? 6 : 4" class="ma-0 pa-0 px-2">
            <v-item v-slot="{ active, toggle }">
              <v-card
                height="100"
                class="pt-4 pa-0"
                @click="toggle"
                v-bind:class="active ? 'animal-select-active-class' : 'white'"
                :elevation="equipmentModel == 0 ? 5 : 1"
              >
                <v-scroll-y-transition>
                  <v-row
                    class="ma-0 pa-0 vetalfa-row"
                    align="center"
                    justify="center"
                  >
                    <v-col class="ma-0 pa-0" align="center">
                      <v-row
                        class="ma-0 pa-0 primary--text font-weight-bold"
                        align="center"
                        justify="center"
                      >
                        Macrogotas
                      </v-row>
                      <p class="ma-0 pa-0 mb-3 black--text caption">
                        (20 gotas/mL)
                      </p>
                    </v-col>
                  </v-row>
                </v-scroll-y-transition>
              </v-card>
            </v-item>
          </v-col>
          <v-col :cols="_isMobile() ? 6 : 4" class="ma-0 pa-0 px-2">
            <v-item v-slot="{ active, toggle }">
              <v-card
                height="100"
                class="pt-4 pa-0"
                @click="toggle"
                v-bind:class="active ? 'animal-select-active-class' : 'white'"
                :elevation="equipmentModel == 1 ? 5 : 1"
              >
                <v-scroll-y-transition>
                  <v-row
                    class="ma-0 pa-0 vetalfa-row"
                    align="center"
                    justify="center"
                  >
                    <v-col class="ma-0 pa-0" align="center">
                      <v-row
                        class="ma-0 pa-0 primary--text font-weight-bold"
                        align="center"
                        justify="center"
                      >
                        Microgotas
                      </v-row>
                      <p class="ma-0 pa-0 mb-3 black--text caption">
                        (60 gotas/mL)
                      </p>
                    </v-col>
                  </v-row>
                </v-scroll-y-transition>
              </v-card>
            </v-item>
          </v-col>
        </v-row>
      </v-item-group>
      <vetalfa-section-title
        :prop="_getLabel('INSTRUCTIONS')"
        class="mt-5"
      ></vetalfa-section-title>
      <vetalfa-section-item
        :prop="_getCalculatorsLabel('DROPS_TO_VOLUME_INSTRUCTIONS')"
      ></vetalfa-section-item>
      <v-row justify="center" class="mt-8" no-gutters>
        <v-card
          @click="dropBtnClick"
          color="primary"
          class="vetalfa-pointer py-4"
          width="140px"
          elevation="5"
          style="border-radius: 24px"
        >
          <v-row justify="center" align="center" no-gutters>
            <v-icon color="white" size="80">{{ _icon("drop") }}</v-icon>
          </v-row>
        </v-card>
      </v-row>
      <vetalfa-section-title
        :prop="_getLabel('RESULTS')"
        class="mt-8"
        v-if="clicks.length == 1"
      >
        <vetalfa-section-item
          prop="Clique mais de uma vez para ver o resultado."
        ></vetalfa-section-item>
      </vetalfa-section-title>
      <vetalfa-section-title
        :prop="_getLabel('RESULTS')"
        v-if="clicks.length > 1"
        class="mt-6"
      >
        <vetalfa-section-item-title
          :prop="_getCalculatorsLabel('SPEED')"
        ></vetalfa-section-item-title>
        <vetalfa-section-item :prop="`${speed} mL/hora`"></vetalfa-section-item>
        <vetalfa-section-item-title
          :prop="_getLabel('COUNT')"
        ></vetalfa-section-item-title>
        <vetalfa-section-item
          :prop="`${clicks.length} cliques em ${elapsedSeconds} segundos.`"
        ></vetalfa-section-item>
      </vetalfa-section-title>
      <v-row justify="center" no-gutters class="mt-10">
        <v-btn
          class="primary text-none px-10"
          center
          rounded
          v-if="clicks.length > 1"
          large
          @click="clicks = []"
          >{{ _getLabel("RESTART") }}</v-btn
        >
      </v-row>
      <div style="height: 70px; background-color: white"></div>
    </div>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { mdiWaterOutline } from "@mdi/js";

import calculatorLabels from "@/constants/labels/calculators.labels.js";
import BigNumber from "bignumber.js";
export default {
  name: "DropsToVolumeCalculator",
  computed: {
    ...mapGetters("drugs", ["category"]),
    ...mapGetters("calculators", ["calculator"]),
    elapsedSeconds() {
      return this.clicks.length < 2
        ? 0
        : this._formatNumber(
            this._roundNumber(
              new BigNumber(this.clicks[this.clicks.length - 1])
                .minus(this.clicks[0])
                .dividedBy(1000),
              2
            )
          );
    },
    speed() {
      return this.clicks.length < 2
        ? 0
        : this._formatNumber(
            this._roundNumber(
              new BigNumber({ 0: 180, 1: 60 }[this.equipmentModel])
                .dividedBy(
                  new BigNumber(this.clicks[this.clicks.length - 1])
                    .minus(this.clicks[0])
                    .dividedBy(1000)
                )
                .times(this.clicks.length - 1),
              2
            )
          );
    },
  },
  props: {
    componentMode: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    ...mapActions("calculators", ["openCalculatorById"]),
    dropBtnClick() {
      this.clicks.push(new Date().getTime());
      this.$nextTick(() => {
        this.$vuetify.goTo(
          "#" + this._createIdentifier(this._getLabel("RESULTS")),
          {
            duration: 0,
            offset: this.$refs.screenHeader.offsetHeight,
            easing: "easeInOutCubic",
          }
        );
      });
    },
  },
  watch: {
    equipmentModel() {
      this.clicks = [];
    },
  },
  data() {
    return {
      calculatorLabels,
      equipmentModel: 0,
      mdiWaterOutline,
      clicks: [],
    };
  },
  mounted() {
    if (this.calculator) {
      this._setupScreenSizes(this);
    }
  },
  created: async function () {
    if (
      !this.calculator ||
      this.calculator.id !== calculatorLabels.DROPS_TO_VOLUME
    ) {
      await this.openCalculatorById({
        id: calculatorLabels.DROPS_TO_VOLUME,
        redirect: false,
      });
      this._setupScreenSizes(this);
    }
  },
};
</script>
